(function () {
  var bar = document.getElementById('CartReminderBar');
  if (!bar) return;

  var summaryEl = bar.querySelector('[data-cart-reminder-summary]');
  var itemOne = bar.dataset.itemOne || '1 Item';
  var itemOther = bar.dataset.itemOther || '__count__ Items';
  var fetching = false;
  var lastCount = Number(bar.dataset.itemCount) || 0;
  var refreshTimer = null;

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    var value = (Number(cents) / 100).toFixed(2);
    return '$' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function itemLabel(count) {
    if (count === 1) return itemOne;
    return itemOther.replace('__count__', String(count));
  }

  function isDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function syncHeight(visible) {
    var height = visible ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--height-cart-reminder', height + 'px');
    window.dispatchEvent(
      new CustomEvent('sticky-cart:change', {
        detail: { visible: visible, height: height, source: 'cart-reminder' },
      })
    );
  }

  function applyVisibility() {
    var show = lastCount > 0 && !isDrawerOpen();
    if (show) {
      bar.hidden = false;
      bar.classList.add('is-visible');
      document.body.classList.add('has-cart-reminder-bar');
      syncHeight(true);
    } else {
      bar.classList.remove('is-visible');
      document.body.classList.remove('has-cart-reminder-bar');
      syncHeight(false);
      if (lastCount < 1) bar.hidden = true;
    }
  }

  function updateFromCart(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    lastCount = Number(cart.item_count) || 0;
    bar.dataset.itemCount = String(lastCount);

    if (summaryEl && lastCount > 0) {
      summaryEl.textContent = itemLabel(lastCount) + ' · ' + formatMoney(cart.total_price);
    }

    applyVisibility();
  }

  function refreshCart() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (fetching) return;
      fetching = true;
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
        credentials: 'same-origin',
      })
        .then(function (res) {
          return res.json();
        })
        .then(updateFromCart)
        .catch(function () {})
        .finally(function () {
          fetching = false;
        });
    }, 80);
  }

  function urlLooksLikeCartMutation(url) {
    var value = typeof url === 'string' ? url : url && url.url ? url.url : '';
    return /\/cart\/(add|change|update|clear)/.test(value);
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var request = arguments[0];
      return originalFetch.apply(this, arguments).then(function (response) {
        if (urlLooksLikeCartMutation(request) && response && response.ok) {
          refreshCart();
        }
        return response;
      });
    };
  }

  if (window.jQuery) {
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (settings && urlLooksLikeCartMutation(settings.url)) refreshCart();
    });
  }

  function cartFromEvent(event) {
    var detail = (event && event.detail) || event || {};
    return detail.cartData || detail.cart || detail;
  }

  function onCartEvent(event) {
    var cart = cartFromEvent(event);
    if (cart && typeof cart.item_count !== 'undefined') {
      updateFromCart(cart);
      return;
    }
    refreshCart();
  }

  document.addEventListener('cart:updated', onCartEvent);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      onCartEvent({ detail: event });
    });
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(applyVisibility).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  window.addEventListener('resize', function () {
    if (bar.classList.contains('is-visible')) syncHeight(true);
  });

  applyVisibility();

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refreshCart();
  });
})();
